export default __webpack_public_path__ + "static/media/m_use_action_back_zc.3ee1ad3c.png";